import { StyledIconWrapper } from './styles'

export const listCommonStyles = {
    root: {
        '&:hover': {
            [`${StyledIconWrapper}`]: {
                background: 'var(--color-white)'
            }
        }
    }
}
